"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _FormattedNumber = _interopRequireDefault(require("./FormattedNumber"));

var _NumberTypes = _interopRequireDefault(require("../constants/NumberTypes"));

var _default = (0, _createReactClass.default)({
  displayName: "FormattedPercentage",
  propTypes: {
    precision: _propTypes.default.number,
    stripInsignificantZeros: _propTypes.default.bool,
    value: _propTypes.default.number.isRequired
  },
  render: function render() {
    return _react.default.createElement(_FormattedNumber.default, Object.assign({
      style: _NumberTypes.default.PERCENTAGE
    }, this.props));
  }
});

exports.default = _default;
module.exports = exports.default;